import type { Report } from '@reports/domain/entities';
import type { BlockDataRequestDto } from '@reports/application/dtos';

/**
 * Actions for the reports domain
 *
 * Each action represents a specific state change operation.
 *
 * @example
 * const action: ReportsAction = {
 *   type: ReportsActions.SELECT_REPORT,
 *   payload: { report: Report },
 * };
 */
export const ReportsActions = {
  SELECT_REPORT: 'SELECT_REPORT',
  UPDATE_FILTERS: 'UPDATE_FILTERS',
  RESET_FILTERS: 'RESET_FILTERS',
  SET_INITIALIZED: 'SET_INITIALIZED',
} as const;

/**
 * Action type for the reports domain
 */
export type ReportsActionType = typeof ReportsActions[keyof typeof ReportsActions];

export type ReportsAction =
  | { type: typeof ReportsActions.SELECT_REPORT; payload: { report: Report } }
  | { type: typeof ReportsActions.UPDATE_FILTERS; payload: { filters: BlockDataRequestDto } }
  | { type: typeof ReportsActions.RESET_FILTERS }
  | { type: typeof ReportsActions.SET_INITIALIZED };
